import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  visitor = [] as any;

  constructor(public services: ApiService) { }

  ngOnInit(): void {
    this.getCounter()
  }

  async getCounter() {
    let visitor: any
    let counnt_visitor: any;
    this.visitor = [];
    
    await this.services.get('m_countofuser').then((res: any) => {
      visitor = res
      counnt_visitor = (visitor.length).toString()
    })
    for (let j = 0; j < counnt_visitor.length; j++) {
      this.visitor.push(counnt_visitor[j])
    }
    for (let x = 0; x < 6; x++) {
      if (this.visitor.length < 6) {
        this.visitor.splice(0, 0, 0);
      }
    }
  }

}
